import Vue from 'vue';

export default {
    getLocations(context, data) {
        console.log(data);
        let url = 'v1/locations';
        const locale = window.afConfig?.default_country_code || 'AU';
        return Vue.$axios.$get(url, { params: { ...data, locale, limit: 50 } });
    },

    getAllLocations(context, data) {
        console.log(data);
        let url = 'v1/locations';
        return Vue.$axios.$get(url, { params: { ...data, show_all: true, limit: 50 } });
    },

     getCountries(context, data) {
        let url = 'v1/countries';
        return Vue.$axios.$get(url, { params: { ...data } });
    },
};
